import { IconCopy, IconShare, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookMessengerIcon,
    FacebookMessengerShareButton,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterShareButton,
    ViberIcon,
    ViberShareButton,
    WhatsappIcon,
    WhatsappShareButton,
    XIcon
} from "react-share";
import IconButton from '../../../components/Buttons/IconButton';
import { toast } from 'sonner';

const LinkShareModal = ({ shareUrl, type }) => {

    const title = `Hey ✋ check out this ${type || 'page'} on advy.me 🌐 \nLink🔗`;

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => setShow(true);

    function onCopy() {
        navigator.clipboard
            .writeText(shareUrl)
            .then(() => {
                toast.success("Link copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    return (
        <>
            <IconButton icon={< IconShare size={16} />} text={"Share"} onClickFunction={() => handleShow()} />
            <Modal show={show} onHide={handleClose} centered >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Share Your Attriva Link</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='px-5 py-2 pb-4'>
                        <div className="flex flex-wrap items-center gap-3 justify-center mb-3">
                            <WhatsappShareButton
                                url={shareUrl}
                                title={title}
                                separator=" :: "
                                className="Demo__some-network__share-button"
                            >
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                            <FacebookShareButton
                                url={shareUrl}
                                className="Demo__some-network__share-button"
                            >
                                <FacebookIcon size={32} round />
                            </FacebookShareButton>
                            <TwitterShareButton
                                url={shareUrl}
                                title={title}
                                className="Demo__some-network__share-button"
                            >
                                <XIcon size={32} round />
                            </TwitterShareButton>
                            <EmailShareButton
                                url={shareUrl}
                                subject={title}
                                body="body"
                                className="Demo__some-network__share-button"
                            >
                                <EmailIcon size={32} round />
                            </EmailShareButton>
                            <LinkedinShareButton
                                url={shareUrl}
                                className="Demo__some-network__share-button"
                            >
                                <LinkedinIcon size={32} round />
                            </LinkedinShareButton>
                            <TelegramShareButton
                                url={shareUrl}
                                title={title}
                                className="Demo__some-network__share-button"
                            >
                                <TelegramIcon size={32} round />
                            </TelegramShareButton>
                            <ViberShareButton
                                url={shareUrl}
                                title={title}
                                className="Demo__some-network__share-button"
                            >
                                <ViberIcon size={32} round />
                            </ViberShareButton>
                            <FacebookMessengerShareButton
                                url={shareUrl}
                                appId="521270401588372"
                                className="Demo__some-network__share-button"
                            >
                                <FacebookMessengerIcon size={32} round />
                            </FacebookMessengerShareButton>
                        </div>

                        <div className="border-2 flex items-center justify-between px-3 py-2 rounded-md">
                            <p className="mb-0 text-sm">{shareUrl}</p>
                            <IconButton icon={<IconCopy size={18} />} onClickFunction={() => onCopy()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LinkShareModal